import { t } from "@lingui/macro";
import * as React from "react";
import { Circle } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const MistIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" title={t`Mist`} {...props}>
    <Circle cx={5} cy={11} r={1} fill="currentColor" />
    <Circle cx={8} cy={8} r={1} fill="currentColor" />
    <Circle cx={11} cy={5} r={1} fill="currentColor" />
    <Circle cx={2} cy={8} r={1} fill="currentColor" />
    <Circle cx={2} cy={2} r={1} fill="currentColor" />
    <Circle cx={5} cy={5} r={1} fill="currentColor" />
    <Circle cx={8} cy={2} r={1} fill="currentColor" />
    <Circle cx={11} cy={11} r={1} fill="currentColor" />
    <Circle cx={8} cy={14} r={1} fill="currentColor" />
    <Circle cx={14} cy={8} r={1} fill="currentColor" />
    <Circle cx={14} cy={14} r={1} fill="currentColor" />
  </Icon>
);

export default MistIcon;
